/*
markup-encoder.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('markupEncoder',['angular'], function () {

    var dependencies = [];

    var mod = angular.module('Services.MarkupEncoder', dependencies);

    mod.factory('markupEncoderService', function () {

        // utility function to perform a strict test if a variable is a string
        function isString(it) {
            if (typeof it === 'undefined' || it === null) {
                return false;
            }
            return (it.constructor && it.constructor.name === 'String');
        }

        // core function that encodes any string content of an object;
        // performs a walk-through of the object, using recursion
        // if a string attribute is encountered, the '<' and '>' characters
        // are replaced with their encode values ('&lt;' and '&gt;', respectively)
        function encodeMarkup(node) {
            if (!node) {
                return;
            }
            if (isParameterNameStringOrArrayOrObject(node.constructor)) {
                switch (node.constructor.name) {
                    case 'Object':
                        for (var attr in node) {
                            if (isString(node[attr])) {
                                var contentStr = node[attr];
                                node[attr] = contentStr.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                            } else {
                                encodeMarkup(node[attr]);
                            }
                        }
                        break;
                    case 'Array':
                        for (var i = 0; i < node.length; i++) {
                            if (isString(node[i])) {
                                node[i] = encodeURI(node[i]);
                            } else {
                                encodeMarkup(node[i]);
                            }
                        }
                        break;
                    default:
                        return;
                }
            }
        }

        function isParameterNameStringOrArrayOrObject(parameter) {
            return parameter &&
                (parameter.name === 'String' ||
                    parameter.name === 'Array' ||
                    parameter.name === 'Object'
                );
        };

        return {
            encodeMarkup: encodeMarkup
        };

    });
});

